var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"cx-sec"},[_c('router-link-localed',{attrs:{"to":"/barrier-free-access-guide"}},[_vm._v("Accessibility")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }